export default "__VITE_ASSET__DOZEh_pt__"